import { render, staticRenderFns } from "./OsItemsList.vue?vue&type=template&id=39610946&"
import script from "./OsItemsList.vue?vue&type=script&lang=js&"
export * from "./OsItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports